<template>
   <div class="att-scroll-content" ref="attScrollContent">
      <slot>No content to scroll.</slot>
   </div>
</template>

<script>

    export default {
        name: 'ScrollContent',
        data() {
            return {}
        }
    }
</script>

<style lang="scss">
   @import "../scss/the-goods";

   .att-scroll-content {
      position     : relative;
      width        : 50%;
      left         : 50%;
   }
</style>



// WEBPACK FOOTER //
// src/components/ScrollContent.vue